module.exports = {
  "zones": {
    "Pacific/Nauru": ["z", {
      "wallclock": 287460000000,
      "format": "+12",
      "abbrev": "+12",
      "offset": 43200000,
      "posix": 287418600000,
      "save": 0
    }, {
      "wallclock": -767318400000,
      "format": "+1130",
      "abbrev": "+1130",
      "offset": 41400000,
      "posix": -767350800000,
      "save": 0
    }, {
      "wallclock": -862876800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -862918200000,
      "save": 0
    }, {
      "wallclock": -1545091200000,
      "format": "+1130",
      "abbrev": "+1130",
      "offset": 41400000,
      "posix": -1545131260000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 40060000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};